import axios from 'axios';
import { config } from '../config';
import { getCookie, deleteCookie } from '../utils/cookies';

const api = axios.create({
  baseURL: config.apiUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token (this will run after the debug interceptor)
api.interceptors.request.use(
  (config) => {
    const token = getCookie('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid
      deleteCookie('authToken');
      deleteCookie('user');
      deleteCookie('lastPath');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// Statistics API functions
export const statisticsApi = {
  getUserStatistics: async (userId: string) => {
    const response = await api.get(`/users/${userId}/stats`);
    return response.data;
  },
};

export default api;
